module.exports = __webpack_public_path__ + "images/feature/141110_zoom_2-390160e06aa55bc74b0d3000cdd4f6e4.png";